import * as React from "react";
import * as _ from "lodash";
import { FormattedMessage } from "react-intl";
import { Headlines, StampContext } from "tp/shared/timeclock/messages";
import { Button, List, ListItemText } from "@mui/material";
import { StampCostDivision } from "tp/shared/timeclock/models";
import { Black } from "tp/shared/common-design/colors";
import { BackButton } from "tp/views/common-forms/components";

interface SelectCompanyProps {
    costDivisions: StampCostDivision[];
    onBackClick: () => void;
    onSelect: (number) => void;
}

interface SelectCompanyState {
    showDivision: boolean;
    company: string;
}

export default class SelectCompany extends React.Component<SelectCompanyProps, SelectCompanyState> {
    constructor(props: SelectCompanyProps) {
        super(props);

        this.state = {
            showDivision: false,
            company: "",
        };
    }

    handleClick = ():void => {
        this.setState({
            showDivision: false,
            company: "",
        });
    };

    showCostDivision(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void {
        this.setState({
            showDivision: true,
            company: e.currentTarget.className
        });
    }

    renderItem(groupKey: string): React.ReactElement {
        return (
            <a href="#" key={-1} onClick={e => this.showCostDivision(e)} className={groupKey} style={{textDecoration: "none"}}>
                <Button
                    variant="contained"
                    className="tc-list-entry"
                    style={{ maxWidth: "240px", minWidth: "160px", display: "inline-block" }}
                >
                    {groupKey}
                </Button>
            </a>
        );
    }

    render(): React.ReactElement {
        const { company } = this.state;
        const groups = _(this.props.costDivisions).groupBy("hotelAbbreviation");

        const allCompanies = groups
            .map((group, key) => <div className="column" key={key}><List style={{ paddingBottom: "0px" }}>{this.renderItem(key)}</List></div>)
            .value();

        const allDivisions = [];


        const companies = groups.map((name) => {
            name.map((hotel: StampCostDivision) => {

                if (this.state.company === hotel.hotelAbbreviation) {
                    allDivisions.push(
                        <ListItemText
                            key={hotel.costDivisionRef}
                            className="tc-list-entry"
                            onClick={() => this.props.onSelect(hotel.costDivisionRef)}
                            primary={hotel.costDivisionName}
                        />
                    );
                }

            });
        });

        return (
            <div className="allCompanies">
                {this.state.showDivision ?
                    (<div className="cost-division">
                        <h1><FormattedMessage {...StampContext.ChooseCostDivision} /></h1>
                        <h2 style={{ color: Black, whiteSpace: "pre", overflow: "hidden", lineHeight: "42px", fontSize: "1.7em", paddingLeft: "20px" }}>
                            {company}
                        </h2>
                        <div className="cost-container">
                            {companies}
                            <List style={{ padding: "0" }}>
                                {allDivisions}
                            </List>
                        </div>
                        <BackButton onClick={this.handleClick} />
                    </div>)
                    : (<div>
                        <h1><FormattedMessage {...Headlines.SelectCompany} /></h1>
                        <div className="select-company">{allCompanies}</div>
                        <BackButton onClick={this.props.onBackClick} />
                    </div>)}
            </div>
        );
    }
}
